import { NOTIFICATION } from '@shared/config/constants'

const ZOOM_MIN = 9
const ZOOM_MAX = 22
export const ZOOM_DEFAULT = 14

export const ZURICH_CENTER = {
  lat: 47.3769562,
  lng: 8.5225678,
}

export const SWISS_BOUNDING_BOX = {
  min: {
    lat: 45.81,
    lng: 5.95,
  },
  max: {
    lat: 47.81,
    lng: 10.5,
  },
}

export const DISCOUNT_GROUPS = {
  1: '1',
  2: '2',
  3: '3',
  4: '4',
}

export const AVM_NETWORK_OHAM = 'OHAM'
export const AVM_NETWORK_OMUL = 'OMUL'
export const AVM_NETWORK_MEDBASE = 'MEDBASE'

export const AVM_NETWORK = {
  [AVM_NETWORK_OHAM]: 'OHAMProdukt', // family doctor
  [AVM_NETWORK_OMUL]: 'OMULProdukt', // multiaccess (OKP 2.0)
  [AVM_NETWORK_MEDBASE]: 'S2MUL1Produkt', // multiaccess (old)
}

export const AVAILABILITY_HINT = {
  ACCEPTS_ALL: {
    icon: 'circle-check',
  },
  ACCORDING_FAMILY_DOCTOR: {
    icon: 'exclamation-circle',
    severity: NOTIFICATION.WARNING,
  },
  ACCEPTS_NOBODY: {
    icon: 'ban',
    severity: NOTIFICATION.ERROR,
  }
}

export const NEW_PATIENT_STATUS = {
  ACCEPTS_ALL: 'ACCEPTS_ALL',
  ACCEPTS_NOBODY: 'ACCEPTS_NOBODY',
  ACCEPTS_CHILDREN: 'ACCEPTS_CHILDREN',
  ACCEPTS_FAMILYMEMBERS: 'ACCEPTS_FAMILYMEMBERS',
  ACCORDING_FAMILY_DOCTOR: 'ACCORDING_FAMILY_DOCTOR',
  SPECIALIST_NOT_ELIGIBLE: 'SPECIALIST_NOT_ELIGIBLE',
  STATUS_UNKNOWN: 'STATUS_UNKNOWN',
}

export const GOOGLE_MAP_OPTIONS = {
  mapTypeControl: false,
  streetViewControl: false,
  minZoom: ZOOM_MIN,
  maxZoom: ZOOM_MAX,
  rotateControl: false,
  fullscreenControl: false,
  clickableIcons: false,

  zoomControl: true,
  scaleControl: false,
  disableDefaultUi: false,
  gestureHandling: 'greedy',
}
